var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    clipRule: "evenodd",
    cx: 16,
    cy: 16,
    fill: "#55ACEE",
    fillRule: "evenodd",
    r: 16,
    className: "fill-55acee"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.013 9.896a8.268 8.268 0 0 1-2.359.636A4.047 4.047 0 0 0 25.461 8.3a8.314 8.314 0 0 1-2.608.979 4.134 4.134 0 0 0-2.996-1.275c-2.269 0-4.105 1.807-4.105 4.039 0 .315.036.625.104.923a11.739 11.739 0 0 1-8.461-4.222 3.968 3.968 0 0 0-.559 2.031c0 1.4.728 2.636 1.828 3.363a4.153 4.153 0 0 1-1.858-.507l-.001.051c0 1.958 1.415 3.591 3.293 3.963a4.26 4.26 0 0 1-1.853.07c.521 1.603 2.038 2.771 3.834 2.806a8.323 8.323 0 0 1-6.078 1.672 11.761 11.761 0 0 0 6.295 1.814c7.552 0 11.682-6.156 11.682-11.495 0-.173-.006-.351-.014-.521a8.375 8.375 0 0 0 2.049-2.095z",
    fill: "#1a1818",
    className: "fill-ffffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.468f304213194c7acb63b33a56bf0a07.svg";
export { ForwardRef as ReactComponent };